import type { ListingTrackingContext } from './types';

import { pickActiveFilters } from './pickActiveFilters';

interface BuildManagedListingTrackingContextInput {
	placement: string;
	filters: Record<string, unknown> | null | undefined;
	filteredCount: number;
	page: number;
	perPage: number;
}

export function buildManagedListingTrackingContext(
	input: BuildManagedListingTrackingContextInput
): ListingTrackingContext {
	return {
		placement: input.placement,
		originProperty: null,
		appliedFilters: pickActiveFilters(input.filters),
		total: input.filteredCount,
		page: input.page,
		perPage: input.perPage
	};
}
